import React from "react";
import { Navigate } from "react-router-dom";
import { canAccess } from "../utils/auth";

export default function RoleRoute({ children, menuKey }) {
  const token = localStorage.getItem("token");

  if (!token) return <Navigate to="/login" replace />;

  if (menuKey && !canAccess(menuKey)) return <Navigate to="/dashboard" replace />;

  return children;
}
